import classNames from 'classnames';

import styles from './_index.module.scss';

export interface ActionAreaProps extends React.HTMLAttributes<HTMLDivElement> {
  buttons?: React.ReactNode[];
}

const ActionArea = ({ buttons = [], children, className }: ActionAreaProps) => {
  return (
    <div className={classNames(styles['action-area'], className)}>
      {children}
      {buttons.length && (
        <div className={styles['action-area-footer']}>
          <div className={styles['action-area-footer-container']}>{buttons}</div>
        </div>
      )}
    </div>
  );
};

export default ActionArea;
